module.exports = __webpack_public_path__ + "fonts/varelaround-regular-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Varela_Round/varelaround-regular-webfont.woff2
// module id = 3470
// module chunks = 0